export const options_ms_asset_text_pos = [
    {value: "left", label: '左寄せ'},
    {value: "center", label: '中央寄せ'},
];

export const options_ms_button_color = [
    {value: 'green', label: '緑'},
    {value: 'blue', label: '青'},
    {value: 'blueGreen', label: '青緑'},
    {value: 'lightBlue', label: '水色'},
    {value: 'red', label: '赤'},
    {value: 'orange', label: '橙'},
    {value: 'black', label: '黒'},
    {value: 'deepRed', label: '紅'},
    {value: 'yellow', label: '黄'},
    {value: 'darkGreen', label: '深緑'},
    {value: 'navyBlue', label: '紺'},
    {value: 'purple', label: '紫'},
];

export const options_ms_button_label = [
    {value: '', label: '未選択'},
    {value: 'label_1', label: 'くわしくはこちら'},
    {value: 'label_2', label: '詳しくはこちら'},
    {value: 'label_3', label: '詳細はこちら'},
    {value: 'label_4', label: 'お申込みはこちら'},
    {value: 'label_5', label: '資料請求はこちら'},
    {value: 'label_6', label: '会員登録はこちら'},
    {value: 'label_7', label: 'ご注文はこちら'},
    {value: 'label_8', label: '今すぐチェック！'},
    {value: 'label_9', label: '今すぐゲット！'},
    {value: 'label_10', label: '今すぐダウンロード！'},
    {value: 'label_11', label: '解答を見る'},
    {value: 'label_12', label: '今すぐクリック！'},
    {value: 'label_13', label: '今すぐもらう'},
    {value: 'label_14', label: '正解はコチラ！'},
    {value: 'label_15', label: '占ってみる！'},
    {value: 'label_16', label: '答えはコチラ！'},
    {value: 'label_17', label: '答えを見る'},
    {value: 'label_18', label: '答え合わせはコチラ'},
    {value: 'label_19', label: '答え合わせをする'},
    {value: 'label_20', label: '▼くわしくはこちら▼'},
    {value: 'label_21', label: '▼結果を見る▼'},
    {value: 'label_22', label: 'もっと見る'},
    {value: 'label_23', label: 'さっそく占う！'},
    {value: 'label_24', label: 'スタンプをゲット！'},
    {value: 'label_25', label: 'スタンプをもらう'},
    {value: 'label_26', label: 'ダウンロードする↓'},
    {value: 'label_27', label: 'プレゼントはこちら'},
];

export const options_ms_line_color = [
    {value: '#4CAF50', label: '緑'},          //#4CAF50
    {value: '#2196F3', label: '青'},           //#2196F3
    {value: '#009688', label: '青緑'},    //#009688
    {value: '#00BCD4', label: '水色'},    //#00BCD4
    {value: '#E91E63', label: '赤'},            //#E91E63
    {value: '#FF9800', label: '橙'},         //#FF9800
    {value: '#000000', label: '黒'},          //#000000
    {value: '#CC0033', label: '紅'},        //#CC0033
    {value: '#FFF10F', label: '黄'},         //#FFF10F
    {value: '#336045', label: '深緑'},    //#336045
    {value: '#2719B2', label: '紺'},        //#2719B2
    {value: '#8E00CC', label: '紫'},         //#8E00CC
];

export const MSG = {
    ERR_GET_ADASSET: "広告アセット情報取得に失敗しました。",
    SUCCESS_POST_ADASSET: "広告アセット情報作成に成功しました。",
    SUCCESS_COPY_ADASSET: "広告アセット情報複製に成功しました。",
    SUCCESS_PUT_ADASSET: "広告アセット情報更新に成功しました。",
    ERR_GET_ACCOUNT: "アカウント情報取得に失敗しました。",
    ERR_POST_ADASSET: "広告アセット情報作成に失敗しました。",
    ERR_COPY_ADASSET: "広告アセット情報複製に失敗しました。",
    ERR_PUT_ADASSET: "広告アセット情報更新に失敗しました。",
}

export const RESULT_ACCOUNT_ERROR = -1

export const RESULT_KBN = {
    SUCCESS: 0,
    INFO: 1,
    ERROR: -9,
}
export const BLANK = ""
export const FULL_SPACE = "　"

// Apollo共通
export const INVALID_CONTROL_CHAR = [
    "\t",
]

// Apollo共通(水平タブのみでなく垂直タブを含め禁止する)
export const INVALID_TAB_CHARS = [
    "\t",
    "\v",
]

//文字コード
export const SHIFT_JIS = "Shift_JIS"

// MS広告アセット　URL許容文字
export const URL_VALID_START_PATTERN_START = /^https*.*$/
export const URL_VALID_CHAR_PATTERN = /^[!#-&(-;=?-[\]_a-{}-~]*$/

// MS広告アセット　テキスト禁止文字
export const INVALID_SUBJECT_TEXT_SYMBOL_CHAR = [
    "<>&\" \\\\",
    ]

export const INVALID_SUBJECT_TEXT_CHAR = [
    "\\\\",
    ]

// レポート管理機能 SQLインジェクション文字
export const INVALID_SQL_CHAR_REPORT = [
    "\"'",
]

export const INVALID_TEXT_CHAR = [
    //NEC特殊文字(Windows機種依存文字)
    "①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪",
    //NEC 選定 IBM 拡張文字(Windows機種依存文字)
    "纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂",
/*　「NEC特殊文字」および「NEC選定 IBM文字」と被っているため、対象外とする。
    //IBM 拡張文字(Windows機種依存文字)
    "ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤'＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑",
*/
]

// レポート管理機能 禁止文字
// 既存の「INVALID_TEXT_CHAR」から、〇付文字、ローマ数字、"髙"を許容
export const INVALID_TEXT_CHAR_REPORT = [
    // NEC特殊文字(Windows機種依存文字)
    "㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡㍻〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪",
    // NEC 選定 IBM 拡張文字(Windows機種依存文字)
    "纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑￢￤＇＂",
/*　「NEC特殊文字」および「NEC選定 IBM文字」と被っているため、対象外とする。
    //IBM 拡張文字(Windows機種依存文字)
    "ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤'＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑",
*/
]

export const PREFIX_REQUEST_PARAM = "?"

export const INVALID_TEXT_CHAR_JOINED = INVALID_TEXT_CHAR.join(BLANK);

export const INVALID_TEXT_CHAR_REPORT_JOINED = INVALID_TEXT_CHAR_REPORT.join(BLANK);

export const SUBJECT_VALID_PATTERN = new RegExp("^([^" + INVALID_SUBJECT_TEXT_SYMBOL_CHAR.concat(INVALID_TEXT_CHAR_JOINED).join(BLANK) + "])*$","u");

export const TEXT_VALID_PATTERN = new RegExp("^([^" + INVALID_SUBJECT_TEXT_CHAR.concat(INVALID_TEXT_CHAR_JOINED).join(BLANK) + "])*$","u");

export const TEXT_VALID_CONTROL_CHAR_PATTERN = new RegExp("^([^" + INVALID_CONTROL_CHAR.join(BLANK) + "])*$","u");

export const TEXT_VALID_TAB_CHAR_PATTERN = new RegExp("^([^" + INVALID_TAB_CHARS.join(BLANK) + "])*$","u");

export const SPACE_START_CHAR_PATTERN = new RegExp("^[^ 　].*$","u");

export const SPACE_END_CHAR_PATTERN = new RegExp("^.*[^ 　]$","u");

export const TEXT_VALID_PATTERN_DOUBLE_QUOTE = new RegExp("^[^\"]*$","u");

export const DOT_START_CHAR_PATTERN = new RegExp("^[^.].*$","u");

export const TEXT_VALID_PATTERN_REPORT = new RegExp("^([^" + INVALID_SUBJECT_TEXT_CHAR.concat(INVALID_TEXT_CHAR_REPORT_JOINED).join(BLANK) + "])*$","u");

export const SQL_VALID_CHAR_REPORT_PATTERN = new RegExp("^([^" + INVALID_SQL_CHAR_REPORT.join(BLANK) + "])*$","u");
